import { useEffect } from 'react';

export const useScrollToTop = (deps: unknown[] = []) => {
  useEffect(() => {
    document.getElementById('main-content')?.scrollTo({ top: 0, behavior: 'smooth' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};
